import { render } from "./BaseRadio.vue?vue&type=template&id=6e6e2b70&scoped=true&lang=pug"
import script from "./BaseRadio.vue?vue&type=script&lang=js"
export * from "./BaseRadio.vue?vue&type=script&lang=js"

import "./BaseRadio.vue?vue&type=style&index=0&id=6e6e2b70&lang=scss&scoped=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e6e2b70"]])

export default __exports__